'use client';

import { RadioGroup, Skeleton } from '@backyard-ui/core';

import { algolia } from '@/infra/tracking/algolia';
import { useProductStore } from '@/presenters/store/catalog/product';

import { Item } from './components';
import useSellersOptions from './use-sellers-options';

export type OptionProps = {
  itemId: number;
};

function Options(props: Readonly<OptionProps>) {
  const { itemId } = props;

  const { currentSeller, handleSellerChange, isFetching, sellers } =
    useSellersOptions(itemId);

  const {
    data: shipments,
    isFetching: shipmentIsFetching,
    isFetched: shipmentIsFetched,
  } = useProductStore((store) => store.shipments);

  if (isFetching) {
    return <Skeleton height="190px" data-testid="sellers-options-skeleton" />;
  }

  if (!sellers || sellers.length < 2) return null;

  const sellersToDisplay = sellers.slice(0, 3);

  return (
    <RadioGroup.Root
      value={currentSeller.id}
      onValueChange={handleSellerChange}
      UNSAFE_className="w-full gap-0 space-y-2 px-4"
    >
      {sellersToDisplay?.map((seller) => (
        <RadioGroup.Item
          key={seller.id}
          value={seller.id}
          UNSAFE_className="items-start py-3 [&>button]:shrink-0 [&>label]:grow"
          onClick={() => algolia.sendPdpClickEvent()}
        >
          <Item
            isSelected={currentSeller.id === seller.id}
            seller={seller}
            shipment={{
              data: shipments[seller.id],
              isFetched: shipmentIsFetched,
              isFetching: shipmentIsFetching,
            }}
          />
        </RadioGroup.Item>
      ))}
    </RadioGroup.Root>
  );
}

export default Options;
